"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ExportsModuleConfigBuilder = /** @class */ (function () {
    function ExportsModuleConfigBuilder() {
    }
    ExportsModuleConfigBuilder.prototype.build = function (scriptsConfig, shim) {
        scriptsConfig.forEach(function (module) {
            if (module.exportName !== undefined && module.exportName !== null) {
                if (shim[module.moduleName] === undefined || shim[module.moduleName] === null) {
                    shim[module.moduleName] = {};
                }
                shim[module.moduleName].exports = module.exportName;
            }
        });
    };
    return ExportsModuleConfigBuilder;
}());
exports.ExportsModuleConfigBuilder = ExportsModuleConfigBuilder;
//# sourceMappingURL=ExportsModuleConfigBuilder.js.map